import {
  imageExtensions,
  msExcelExtensions,
  msPowerPointExtensions,
  msWordExtensions,
  pdfExtension,
  videoExtensions,
} from '~/client/src/shared/stores/domain/FileUploading.store'

export type FileKind =
  | 'image'
  | 'video'
  | 'pdf'
  | 'word'
  | 'excel'
  | 'ppt'
  | 'other'

export function getFileKind(fileName: string): FileKind {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? ''
  if (imageExtensions.includes(ext)) return 'image'
  if (videoExtensions.includes(ext)) return 'video'
  if (ext === pdfExtension) return 'pdf'
  if (msWordExtensions.includes(ext)) return 'word'
  if (msExcelExtensions.includes(ext)) return 'excel'
  if (msPowerPointExtensions.includes(ext)) return 'ppt'
  return 'other'
}

export function getFileTypeText(kind: FileKind): string | null {
  switch (kind) {
    case 'image':
      return 'Image'
    case 'video':
      return 'Video'
    case 'pdf':
      return 'PDF'
    case 'word':
      return 'MS Word'
    case 'excel':
      return 'MS Excel'
    case 'ppt':
      return 'MS PowerPoint'
    default:
      return null
  }
}
